const WEBGL_CONTEXT_NAMES = ['webgl2', 'webgl', 'experimental-webgl'] as const;

export const isWebGLEnabled = (): boolean => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  // oxlint-disable-next-line typescript/no-unnecessary-condition
  if (!window.WebGLRenderingContext && !window.WebGL2RenderingContext) return false;

  const canvas = document.createElement('canvas');

  for (const contextName of WEBGL_CONTEXT_NAMES) {
    try {
      const context = canvas.getContext(contextName) as WebGLRenderingContext | WebGL2RenderingContext | null;

      if (context) {
        try {
          context.getExtension('WEBGL_lose_context')?.loseContext();
        } catch {}
        return true;
      }
    } catch {}
  }

  return false;
};
